//API Loader Events
export const SHOW_API_LOADING = "api:show_loader"
export const HIDE_API_LOADING = "api:hide_loader"

export const SAVED_PROFILE_IMAGE = "api:saved_profile_image"

export const PAYSAFE_TOKENIZED = "paysafe:tokenized"
